import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const AdminCalendar = ({ events }) => {
  const navigate = useNavigate();
  // Simple Arabic-style calendar view or just a chronological list of upcoming events
  // For a "calendar" experience, we'll group events by month

  const sortedEvents = [...events].sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));

  const months = {
    0: "يناير", 1: "فبراير", 2: "مارس", 3: "أبريل", 4: "مايو", 5: "يونيو",
    6: "يوليو", 7: "أغسطس", 8: "سبتمبر", 9: "أكتوبر", 10: "نوفمبر", 11: "ديسمبر"
  };

  const groupedByMonth = sortedEvents.reduce((acc, event) => {
    const date = new Date(event.eventDate || event.createdAt);
    const monthYear = `${months[date.getMonth()]} ${date.getFullYear()}`;
    if (!acc[monthYear]) acc[monthYear] = [];
    acc[monthYear].push(event);
    return acc;
  }, {});

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="space-y-6"
    >
      <div className="d-flex align-items-center gap-3 mb-4">
        <div className="bg-primary-dim p-2 rounded-4">
          <span className="material-symbols-outlined text-primary">calendar_month</span>
        </div>
        <h3 className="h3 font-black font-headline mb-0">جدول المناسبات</h3>
      </div>

      {Object.keys(groupedByMonth).length === 0 ? (
        <div className="text-center py-5 bg-white rounded-celebration border border-dashed border-primary-dim">
           <p className="text-muted fw-bold mb-0">لا يوجد مناسبات مجدولة حالياً.</p>
        </div>
      ) : (
        Object.keys(groupedByMonth).map(month => (
          <div key={month} className="mb-5">
            <h4 className="h5 fw-black text-primary mb-3 px-2 border-end border-primary border-4">{month}</h4>
            <div className="row g-3">
              {groupedByMonth[month].map(ev => (
                <div key={ev._id} className="col-md-6 col-lg-4">
                  <div className="bg-white p-4 rounded-celebration shadow-sm border border-light h-100 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="bg-light p-2 rounded-3 text-primary fw-black text-center" style={{ minWidth: '50px' }}>
                        <div className="text-xs opacity-70">{months[new Date(ev.eventDate).getMonth()]}</div>
                        <div className="fs-4">{new Date(ev.eventDate).getDate()}</div>
                      </div>
                      <span className={`badge rounded-pill text-xs ${ev.isApproved ? 'bg-success-container text-success' : 'bg-warning-container text-warning'}`}>
                        {ev.isApproved ? 'نشط' : 'قيد المراجعة'}
                      </span>
                    </div>
                    <h5 className="fw-black mb-1">{ev.name}</h5>
                    <p className="text-muted small mb-3">{ev.locationName || "مكان غير محدد"}</p>
                    <div className="mt-auto pt-3 border-top d-flex justify-content-between align-items-center">
                       <span className="text-xs fw-bold text-muted uppercase">بواسطة: {ev.owner}</span>
                       <button
                         className="btn btn-sm btn-link text-primary p-0 fw-bold text-decoration-none"
                         onClick={() => navigate(`/admin/event/${ev._id || ev.id}`)}
                       >
                         تفاصيل
                       </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      )}
    </motion.div>
  );
};

export default AdminCalendar;
